export class RpeEmit {

    public numVoo: string;
    public dateDTO: string;
    public company: string;
    public origin: string;
    public type: string;
}
